export default __webpack_public_path__ + "static/media/segoepr_0.74c70684.ttf";